import styles from './style.module.scss';

type Props = {
  text?: string
}

const FeatureTag: React.VFC<Props> = ({ text }) => {
  return (
    <p className={styles.featureTag}>#{text}</p>
  )
}

export { FeatureTag }
